import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppService } from "../services/app.service";
import { chkLength as chkLengthUtil } from "../utils/format-util";
import { PatientFormService } from "../services/patient-form.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { MbscDatetimeOptions } from "@mobiscroll/angular";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/typeahead-match.class";
import { SupportService } from "../services/support-service";
import { IMyDpOptions } from "mydatepicker";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-confirming-details",
  templateUrl: "./confirming-details.component.html",
  styleUrls: ["./confirming-details.component.scss"],
})
export class ConfirmingDetailsComponent implements OnInit {
  public myDatePickerOptions: IMyDpOptions = {};
  selectProcedureList: any = [];
  scheduleDetail: any = {};
  confirmForm: FormGroup;
  submitted = false;
  countryList: any = [];
  phonemask = "00000-00000";
  phonemask1 = '00000-00000';
  alternativemask = "00000-00000";
  physicianmask = "00000-00000";
  physicianfaxmask = "00000-00000";
  faxmask = "00000-00000";
  hmomask = "00000-00000";
  physicianList: any = [];
  contryID = "";
  physicianId = "";
  selectedName = "";
  selectedPatientName = "";
  isSubmit = false;
  patientDetail: any = {};
  patientList: any = [];
  testCountryCode: any = "US";
  showMoreDetails = false;
  showPreAuthorized = true;
  showAltNumber: boolean;
  testCenterName = localStorage.getItem("testCenterName");
  medicalqnsList = [];
  formatter: any;
  insuranceList: any = [];
  medicalQnsList = [];
  patient = {};
  stateList: any = [];
  yesSelected = false;
  noSelected = true;
  answered = true;
  medicalqnslist: any = [];
  dateSettings: MbscDatetimeOptions = {};
  subscritionBal = 0;
  medicalQuestionBySchedId: [
    { tcProcedureView: {}; schedMedicalQuestions: [] }
  ];
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private appservice: AppService,
    private support: SupportService,
    private datePipe: DatePipe,
    private patientFormService: PatientFormService
  ) {
    this.dateSettings = {
      dateFormat: "M dd, yyyy",
      display: "center",
      max: new Date(),
    };
  }

  checkQuestion(question, i) {
    return this.patientFormService.checkQuestion(question, i, this.medicalqnsList);
  }

  getTcMedicalQuestionByCptCode() {
    if (
      this.scheduleDetail &&
      this.scheduleDetail.selectedSchedule &&
      this.scheduleDetail.selectedSchedule.procedureInputs
    ) {
      const data = {
        tcId: localStorage.getItem("testCenterId"),
        tcProcedureView: this.scheduleDetail.selectProcedureList,
      };
      this.appservice.getMedicalQuestionByCptcode(data).subscribe((res) => {
        if (res && res["entity"]) {
          this.medicalqnsList = res["entity"];

          this.intialMedicalQuestion("male");
        }
      });
    }
  }

  checkGender(value) {
    this.intialMedicalQuestion(value);
  }

  changed(value, type, index2, medicalqnslist, qnsList) {
    this.patientFormService.changed(value, type, index2, medicalqnslist, qnsList);
  }

  answerChange(input, qnsList) {
    this.patientFormService.answerChange(input, qnsList);
  }

  getMedicalQuestionHeader() {
    return this.patientFormService.getMedicalQuestionHeader(this);
  }

  intialMedicalQuestion(gender) {
    if (this.medicalqnsList && this.medicalqnsList.length > 0) {
      for (let index = 0; index < this.medicalqnsList.length; index++) {
        this.medicalqnsList[index].schedMedicalQuestions.forEach((medical) => {
          if (gender.toLowerCase() === "female") {
            medical.isShow = true;
          } else {
            medical.isShow = true;
            if (
              medical.medicalQuestion.medicalQuestion.gender.toLowerCase() ===
              "female"
            ) {
              medical.isShow = false;
            }
          }
          if (medical.medicalQuestion.medicalQuestion.yesOrNoText === "false") {
            medical.yesOrNoText = false;
          } else {
            medical.yesOrNoText = true;
          }

          if (
            (medical.medicalQuestion.medicalQuestion.question.indexOf(
              "Height"
            ) !== -1 ||
              medical.medicalQuestion.medicalQuestion.question.indexOf(
                "height"
              ) !== -1) &&
            ((medical.medicalQuestion.medicalQuestion.question.indexOf(
              "Weight"
            ) &&
              -1) ||
              (medical.medicalQuestion.medicalQuestion.question.indexOf(
                "weight"
              ) &&
                -1))
          ) {
            medical.isHeightWeight = true;
          } else {
            medical.isHeightWeight = false;
          }
        });
      }
    }
  }

  ngOnInit() {
    this.contryID = localStorage.getItem("countryId").toString();
    if(localStorage.getItem('subscritionBal')) {
      this.subscritionBal = +localStorage.getItem('subscritionBal');
    }
    const scheduleData = sessionStorage.getItem("scheduleData")
      ? JSON.parse(sessionStorage.getItem("scheduleData"))
      : "";
    if (scheduleData) {
      this.scheduleDetail = scheduleData;

      if (
        this.scheduleDetail.payMode &&
        this.scheduleDetail.payMode !== "insurance"
      ) {
        this.showPreAuthorized = true;
      }
      if (
        scheduleData.selectProcedureList &&
        scheduleData.selectProcedureList.length > 0
      ) {
        this.selectProcedureList = scheduleData.selectProcedureList;
        scheduleData.procedureInputs = [];
        scheduleData.procedureInputs =
          scheduleData.selectedSchedule.procedureInputs;
      }
      if (this.scheduleDetail.patientDetail) {
        this.patientDetail = this.scheduleDetail.patientDetail;
      }
    }

    this.loadForm();
    this.getcountry();
    this.getPhysicianList();
    this.getPatientList();
    this.checkMoreDetails(true);

    this.formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
    });
  }

  checkMoreDetails(value) {
    this.showMoreDetails = value;
    if (!this.scheduleDetail.patientDetail) {
      this.insuranceList = [];
      if (this.scheduleDetail.insuranceList.length > 0) {
        for (
          let index = 0;
          index < this.scheduleDetail.insuranceList.length;
          index++
        ) {
          const data = {
            insurance: this.scheduleDetail.insuranceList[index].insName,
            insuranceId: this.scheduleDetail.insuranceList[index].insId,
            insuranceType: this.scheduleDetail.insuranceList[index].insType,
            insuranceIdNumber: "",
            insuranceGroupNumber: "",
            insuranceCustomerService: "",
            insuranceCustomerServiceMask:
              this.testCountryCode === "US"
                ? environment.usPhoneMask
                : environment.indiaPhoneMask,
            insuranceCustomerCode: this.testCountryCode === "US" ? "+1" : "+91",
          };
          this.insuranceList.push(data);
        }
      }
    }
  }

  checkPreAuth(value) {
    if (value) {
      this.confirmForm
        .get("gender")
        .setValidators(Validators.compose([Validators.required]));
      this.confirmForm
        .get("moreDetails")
        .setValidators(Validators.compose([Validators.required]));
      this.confirmForm.get("gender").updateValueAndValidity();
      this.confirmForm.get("moreDetails").updateValueAndValidity();
      this.yesornochecked("no");
    } else {
      this.confirmForm.get("gender").clearValidators();
      this.confirmForm.get("moreDetails").clearValidators();
      this.confirmForm.get("gender").updateValueAndValidity();
      this.confirmForm.get("moreDetails").updateValueAndValidity();
      this.yesornochecked("yes");
      this.checkMoreDetails(false);
    }
    this.showPreAuthorized = value;
  }

  checkAltNum(value) {
    if (value) {
      this.confirmForm.get("alternativeMobile").clearValidators();
      this.confirmForm.get("alternativeMobile").updateValueAndValidity();
    } else if (!value) {
      this.confirmForm
        .get("alternativeMobile")
        .setValidators(
          Validators.compose([Validators.required, Validators.minLength(10)])
        );
      this.confirmForm.get("alternativeMobile").updateValueAndValidity();
    }
    this.showAltNumber = value;
  }

  viewTestCenter() {
    this.appservice.viewtestcenter().subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"] &&
          res["status"]["status"] === 200
        ) {
          if (res["entity"]) {
            this.testCountryCode =
              res["entity"]["address"]["country"]["countryCode"];
            if (this.testCountryCode === "US") {
              this.confirmForm.controls["countrydialcode"].setValue("+1");
              this.confirmForm.controls["alternativeCode"].setValue("+1");
              this.confirmForm.controls["patientCountry"].setValue("231");
              this.getStateList(231);
              this.confirmForm.controls["patientzipmask"].setValue("00000");
              this.confirmForm.controls["physicianMobileCode"].setValue("+1");
              this.confirmForm.controls["faxCode"].setValue("+1");
              this.confirmForm.controls["hmoMobileCode"].setValue("+1");
              this.phonemask = "(000) 000-0000";
              this.alternativemask = "(000) 000-0000";
              this.physicianmask = "(000) 000-0000";
              this.physicianfaxmask = "(000) 000-0000";
              this.faxmask = "(000) 000-0000";
              this.hmomask = "(000) 000-0000";
              this.formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
              });
            } else {
              this.showPreAuthorized = true;
              this.confirmForm.controls["countrydialcode"].setValue("+91");
              this.confirmForm.controls["alternativeCode"].setValue("+91");
              this.confirmForm.controls["patientCountry"].setValue("101");
              this.getStateList(101);
              this.confirmForm.controls["patientzipmask"].setValue("000000");
              this.confirmForm.controls["physicianMobileCode"].setValue("+91");
              this.confirmForm.controls["faxCode"].setValue("+91");
              this.confirmForm.controls["hmoMobileCode"].setValue("+91");
              this.phonemask = "00000-00000";
              this.alternativemask = "00000-00000";
              this.physicianmask = "00000-00000";
              this.physicianfaxmask = "00000-00000";
              this.faxmask = "00000-00000";
              this.hmomask = "00000-00000";
              this.formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "INR",
                minimumFractionDigits: 0,
              });
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  onGoBack() {
    if (
      this.scheduleDetail &&
      this.scheduleDetail.type &&
      this.scheduleDetail.type === "reschedule"
    ) {
      this.router.navigate([
        `/${localStorage.getItem("testCode").toString()}/schedule-appointment/${
          this.scheduleDetail.scheduleId
        }`,
      ]);
    } else {
      this.router.navigate([
        `/${localStorage.getItem("testCode").toString()}/schedule-appointment`,
      ]);
    }
  }

  getPatientList() {
    return this.patientFormService.getPatientList(this);
  }

  setPhysician(event) {
    this.contryID = event.physicianCountry;
    this.confirmForm.controls["countrydialcode"].setValue(
      event.physicianCountry === 101 ? "+91" : "+1"
    );
    this.confirmForm.controls["physicianFirstName"].setValue(
      event.physicianFirstName
    );
    this.confirmForm.controls["physicianLastName"].setValue(
      event.physicianLastName
    );
    this.confirmForm.controls["physicianMobile"].setValue(event.physicianPhone);
    this.confirmForm.controls["physicianMobileCode"].setValue(
      event.physicianPhoneCode
    );
    this.confirmForm.controls["physicianExtn"].setValue(
      event.physicianPhoneExtn
    );
    this.confirmForm.controls["physicianFax"].setValue(event.physicianFax);
    this.confirmForm.controls["faxCode"].setValue(event.physicianFaxCode);
    this.confirmForm.controls["faxExtn"].setValue(event.physicainFaxExtn);
    this.physicianId = event.physicianId;
    this.confirmForm.controls["hmoFirstName"].setValue(
      event.assistantFirstName
    );
    this.confirmForm.controls["hmoLastName"].setValue(event.assistantLastName);
    this.confirmForm.controls["hmoMobile"].setValue(event.assistantPhone);
    this.confirmForm.controls["hmoMobileCode"].setValue(
      event.assistantPhoneCode
    );
    this.confirmForm.controls["hmoExtn"].setValue(event.assistantPhoneExtn);
    this.confirmForm.controls["doctorFirstName"].setValue(
      event.physicianContactFirstName
    );
    this.confirmForm.controls["doctorLastName"].setValue(
      event.physicianContactLastName
    );
    this.selectedName =
      event.physicianFirstName + " " + event.physicianLastName;
  }

  public setDateToDatePicker1(event): any {
    let patientdob = null;
    if (event) {
      const splitDate = event.toString().split("-");
      patientdob = new Date();
      patientdob.setFullYear(+splitDate[0]);
      patientdob.setMonth(+splitDate[1] - 1);
      patientdob.setDate(+splitDate[2]);
      patientdob.setHours(0);
      patientdob.setMinutes(0);
    }
    return patientdob;
  }

  onSelectPatient(event: TypeaheadMatch): void {
    if (event.item.id) {
      this.appservice
        .viewscheduleappointmentwithcheckin(
          "scheduleid",
          event.item.id,
          localStorage.getItem("testCenterId")
        )
        .subscribe((res) => {
          if (res && res["entity"]) {
            this.setPhysician(res["entity"]);
          }
        });
    }

    console.log(event);
    this.confirmForm.controls["firstName"].setValue(event.item.firstName);
    this.confirmForm.controls["firstName1"].setValue(event.item.firstName);
    this.confirmForm.controls["lastName"].setValue(event.item.lastName);
    this.confirmForm.controls["lastName1"].setValue(event.item.lastName);
    this.confirmForm.controls["mobile"].setValue(event.item.patientPhone);
    this.confirmForm.controls["mobile1"].setValue(event.item.patientPhone);
    this.confirmForm.controls["mobileExtn"].setValue(
      event.item.patientPhoneExtn
    );
    let patientPhoneCode = null;
    if (event.item.patientPhoneCode) {
      patientPhoneCode = event.item.patientPhoneCode;
    } else if (this.testCountryCode === "US") {
      patientPhoneCode = "+1";
    } else if (this.testCountryCode === "IN") {
      patientPhoneCode = "+91";
    }

    this.changeMask("phonemask", patientPhoneCode);
    this.confirmForm.controls["countrydialcode"].setValue(patientPhoneCode);
    this.confirmForm.controls["countrydialcode1"].setValue(patientPhoneCode);

    this.confirmForm.controls["email"].setValue(event.item.patientEmail);
    this.confirmForm.controls["email1"].setValue(event.item.patientEmail);
    this.confirmForm.controls["gender"].setValue(event.item.gender);

    this.confirmForm.controls["patientDob"].setValue(
      this.setDateToDatePicker1(event.item.dob)
    );

    this.confirmForm.controls["alternativeMobile"].setValue(
      event.item.altPatientPhone
    );
    this.confirmForm.controls["alternativeExtn"].setValue(
      event.item.altPatientPhoneExtn
    );
    let altPatientPhoneCode = null;
    if (event.item.altPatientPhoneCode) {
      altPatientPhoneCode = event.item.altPatientPhoneCode;
    } else if (this.testCountryCode === "US") {
      altPatientPhoneCode = "+1";
    } else if (this.testCountryCode === "IN") {
      altPatientPhoneCode = "+91";
    }
    this.confirmForm.controls["alternativeCode"].setValue(altPatientPhoneCode);
    this.changeMask("alternativemask", altPatientPhoneCode);

    if (event.item.address) {
      if (event.item.address.country && event.item.address.country.id) {
        this.confirmForm.controls["patientCountry"].setValue(
          event.item.address.country.id
        );
        this.changeCountry(event.item.address.country.id);
        if (
          event.item.address.country.id === 231 ||
          event.item.address.country.id === "231"
        ) {
          this.confirmForm.controls["patientzipmask"].setValue("00000");
          this.confirmForm.controls["patientZipCode"].setValue(
            event.item.address.zipCode
          );
        } else {
          this.confirmForm.controls["patientzipmask"].setValue("000000");
          this.confirmForm.controls["patientZipCode"].setValue(
            event.item.address.zipCode
          );
        }

        if (event.item.address.state && event.item.address.state.id) {
          this.confirmForm.controls["patientState"].setValue(
            event.item.address.state.id
          );
        } else {
          this.confirmForm.controls["patientState"].setValue("");
        }
      } else {
        let countryid = 0;
        if (this.testCountryCode === "US") {
          countryid = 231;
          this.confirmForm.controls["patientzipmask"].setValue("00000");
          this.confirmForm.controls["patientZipCode"].setValue(
            event.item.address.zipCode
          );
        } else {
          countryid = 101;
          this.confirmForm.controls["patientzipmask"].setValue("000000");
          this.confirmForm.controls["patientZipCode"].setValue(
            event.item.address.zipCode
          );
        }
        this.confirmForm.controls["patientCountry"].setValue(countryid);
        this.changeCountry(countryid);
        this.confirmForm.controls["patientState"].setValue("");
      }

      this.confirmForm.controls["patientAddress1"].setValue(
        event.item.address.addressLine1
      );
      this.confirmForm.controls["patientAddress2"].setValue(
        event.item.address.addressLine2
      );
      this.confirmForm.controls["patientCity"].setValue(
        event.item.address.cityName
      );
    }

    this.selectedPatientName = event.item.firstName + " " + event.item.lastName;
  }

  setDateToDatePicker(dateStr) {
    return this.patientFormService.setDateToDatePicker(dateStr);
  }

  loadForm() {
    this.confirmForm = this.formBuilder.group({
      firstName: ["", Validators.required],
      firstName1: ["", Validators.required],
      lastName: ["", Validators.required],
      lastName1: ["", Validators.required],
      countrydialcode: ["+91"],
      countrydialcode1: ["+91"],
      mobile: ['', [Validators.required, Validators.minLength(10)]],
      mobile1: ['', [Validators.required, Validators.minLength(10)]],
      mobileExtn: [''],
      email: ['',
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/),
        ],
      ],
      email1: ['',
      [
        Validators.required,
        Validators.pattern(/^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/),
      ],
    ],
      gender: ["", Validators.required],
      preAutherize: ["true"],
      preNeed: [""],
      preReminder: ["", Validators.required],
      moreDetails: ["true", Validators.required],
      alternativeMobile: ["", [Validators.required, Validators.minLength(10)]],
      alternativeCode: ["+91"],
      alternativeExtn: [""],
      hearAbout: [""],
      hearOthers: [""],
      // PHYSICIAN DETAILS
      physicianFirstName: [""],
      physicianLastName: [""],
      doctorFirstName: [""],
      doctorLastName: [""],
      physicianMobile: ["", Validators.minLength(10)],
      physicianMobileCode: ["+91"],
      physicianExtn: [""],
      physicianFax: ["", Validators.minLength(10)],
      faxCode: ["+91"],
      faxExtn: [""],
      hmoFirstName: [""],
      hmoLastName: [""],
      hmoMobile: ["", Validators.minLength(10)],
      hmoMobileCode: ["+91"],
      hmoExtn: [""],
      //patientdetails
      patientDob: null,
      patientState: [""],
      patientCountry: [""],
      patientCity: [""],
      patientAddress1: [""],
      patientAddress2: [""],
      patientZipCode: [""],
      patientzipmask: [""],
    });
    if (this.scheduleDetail.patientDetail) {
      this.confirmForm.controls["firstName"].setValue(this.patientDetail.patientFirstName);
      this.confirmForm.controls["firstName1"].setValue(this.patientDetail.patientFirstName);
      this.confirmForm.controls["lastName"].setValue(this.patientDetail.patientLastName);
      this.confirmForm.controls["lastName1"].setValue(this.patientDetail.patientLastName);
      this.confirmForm.controls["countrydialcode"].setValue(this.patientDetail.patientPhoneCode === "+91" ? "+91" : "+1");
      this.confirmForm.controls["countrydialcode1"].setValue(this.patientDetail.patientPhoneCode === "+91" ? "+91" : "+1");
      this.confirmForm.controls["mobile"].setValue(this.patientDetail.patientPhone);
      this.confirmForm.controls["mobile1"].setValue(this.patientDetail.patientPhone);
      this.confirmForm.controls["email"].setValue(this.patientDetail.patientEmail);
      this.confirmForm.controls["email1"].setValue(this.patientDetail.patientEmail);
      this.confirmForm.controls["gender"].setValue(
        this.patientDetail.patientGender
      );
      this.changeMask("phonemask", this.patientDetail.patientPhoneCode);
      this.confirmForm.controls["patientDob"].setValue(this.setDateToDatePicker1(this.patientDetail.patientDob));
      this.confirmForm.controls["patientAddress1"].setValue(
        this.patientDetail.patientAddressLine1
      );
      this.confirmForm.controls["patientAddress2"].setValue(
        this.patientDetail.patientAddressLine2
      );
      this.getStateList(this.patientDetail.patientCountry);
      this.confirmForm.controls["patientCity"].setValue(
        this.patientDetail.patientCityName
      );
      this.confirmForm.controls["patientCountry"].setValue(
        this.patientDetail.patientCountry
      );
      this.confirmForm.controls["patientState"].setValue(
        this.patientDetail.patientState
      );
      this.confirmForm.controls["patientZipCode"].setValue(
        this.patientDetail.patientZipCode
      );
      this.confirmForm.controls["patientzipmask"].setValue(
        this.patientDetail.patientCountry === 101 ? "000000" : "00000"
      );

      this.confirmForm.controls["preAutherize"].setValue(
        this.patientDetail.preAuthorized === true ? "true" : "false"
      );
      this.confirmForm.controls["preNeed"].setValue(
        this.patientDetail.answered
      );
      this.confirmForm.controls["preReminder"].setValue(
        this.patientDetail.notification === true ? "true" : "false"
      );
      if (this.patientDetail.notification === false) {
        this.checkAltNum(false);
      } else {
        this.checkAltNum(true);
      }

      if (this.patientDetail.others) {
        this.confirmForm.controls["hearOthers"].setValue(
          this.patientDetail.others
        );
      } else {
        this.confirmForm.controls["hearAbout"].setValue(
          this.patientDetail.hearedAboutUs
        );
      }

      this.confirmForm.controls["alternativeMobile"].setValue(
        this.patientDetail.altPatientPhone
      );
      this.confirmForm.controls["alternativeCode"].setValue(
        this.patientDetail.altPatientPhoneCode === "+91" ? "+91" : "+1"
      );
      this.changeMask(
        "alternativemask",
        this.patientDetail.altPatientPhoneCode
      );

      this.confirmForm.controls["physicianFirstName"].setValue(
        this.patientDetail.physicianFirstName
      );
      this.confirmForm.controls["physicianLastName"].setValue(
        this.patientDetail.physicianLastName
      );
      this.confirmForm.controls["physicianMobile"].setValue(
        this.patientDetail.physicianPhone
      );
      this.confirmForm.controls["physicianMobileCode"].setValue(
        this.patientDetail.physicianPhoneCode === "+91" ? "+91" : "+1"
      );
      this.changeMask("physicianmask", this.patientDetail.physicianPhoneCode);

      this.confirmForm.controls["doctorFirstName"].setValue(
        this.patientDetail.physicianContactFirstName
      );
      this.confirmForm.controls["doctorLastName"].setValue(
        this.patientDetail.physicianContactLastName
      );
      this.confirmForm.controls["physicianFax"].setValue(
        this.patientDetail.physicianFax
      );
      this.confirmForm.controls["faxCode"].setValue(
        this.patientDetail.physicianFaxCode === "+91" ? "+91" : "+1"
      );
      this.changeMask("faxmask", this.patientDetail.physicianFaxCode);

      this.confirmForm.controls["hmoFirstName"].setValue(
        this.patientDetail.assistantFirstName
      );
      this.confirmForm.controls["hmoLastName"].setValue(
        this.patientDetail.assistantLastName
      );
      this.confirmForm.controls["hmoMobile"].setValue(
        this.patientDetail.assistantPhone
      );
      this.confirmForm.controls["hmoMobileCode"].setValue(
        this.patientDetail.assistantPhoneCode === "+91" ? "+91" : "+1"
      );
      this.changeMask("hmomask", this.patientDetail.assistantPhoneCode);

      this.insuranceList = [];
      if (this.scheduleDetail.payMode === "insurance") {
        for (
          let index = 0;
          index < this.scheduleDetail.insuranceList.length;
          index++
        ) {
          const data = {
            insurance: this.scheduleDetail.insuranceList[index].insName,
            insuranceCustomerCode: this.scheduleDetail.insuranceList[index]
              .insuranceCustomerCode
              ? this.scheduleDetail.insuranceList[index].insuranceCustomerCode
              : "",
            insuranceCustomerService: this.scheduleDetail.insuranceList[index]
              .insuranceCustomerService
              ? this.scheduleDetail.insuranceList[index]
                  .insuranceCustomerService
              : "",
            insuranceGroupNumber: this.scheduleDetail.insuranceList[index]
              .insuranceGroupNumber
              ? this.scheduleDetail.insuranceList[index].insuranceGroupNumber
              : "",
            insuranceIdNumber: this.scheduleDetail.insuranceList[index]
              .insuranceIdNumber
              ? this.scheduleDetail.insuranceList[index].insuranceIdNumber
              : "",
            insuranceType: this.scheduleDetail.insuranceList[index].insType,
            insuranceId: this.scheduleDetail.insuranceList[index].insId,
            insuranceCustomerServiceMask: this.scheduleDetail.insuranceList[
              index
            ].insuranceCustomerCode
              ? this.scheduleDetail.insuranceList[index]
                  .insuranceCustomerCode === "+91"
                ? environment.indiaPhoneMask
                : environment.usPhoneMask
              : "",
          };
          this.insuranceList.push(data);
        }
      }

      if (this.patientDetail.patientGender) {
        this.medicalqnsList = [];
        this.appservice
          .getmedicalqns(this.patientDetail.id)
          .subscribe((res) => {
            if (res && res["entity"]) {
              this.medicalqnsList = res["entity"];
              if (this.medicalqnsList && this.medicalqnsList.length > 0) {
                for (
                  let index = 0;
                  index < this.medicalqnsList.length;
                  index++
                ) {
                  this.medicalqnsList[index].schedMedicalQuestions.forEach(
                    (medical) => {
                      if (
                        this.patientDetail.patientGender.toLowerCase() ===
                        "female"
                      ) {
                        medical.isShow = true;
                      } else {
                        medical.isShow = true;
                        if (
                          medical.medicalQuestion.medicalQuestion.gender.toLowerCase() ===
                          "female"
                        ) {
                          medical.isShow = false;
                        }
                      }
                      if (
                        medical.medicalQuestion.medicalQuestion.yesOrNoText ===
                        "false"
                      ) {
                        medical.yesOrNoText = false;
                      } else {
                        medical.yesOrNoText = true;
                      }

                      if (
                        (medical.medicalQuestion.medicalQuestion.question.indexOf(
                          "Height"
                        ) !== -1 ||
                          medical.medicalQuestion.medicalQuestion.question.indexOf(
                            "height"
                          ) !== -1) &&
                        ((medical.medicalQuestion.medicalQuestion.question.indexOf(
                          "Weight"
                        ) &&
                          -1) ||
                          (medical.medicalQuestion.medicalQuestion.question.indexOf(
                            "weight"
                          ) &&
                            -1))
                      ) {
                        medical.isHeightWeight = true;
                      } else {
                        medical.isHeightWeight = false;
                      }
                    }
                  );
                }
              }
            }
          });
      }
    } else {
      this.getTcMedicalQuestionByCptCode();

      if (sessionStorage.getItem("waitinglistpatient")) {
        if (this.patient) {
          this.patient = sessionStorage.getItem("waitinglistpatient")
            ? JSON.parse(sessionStorage.getItem("waitinglistpatient"))
            : null;
          this.confirmForm.controls["firstName"].setValue(
            this.patient["firstName"]
          );
          this.confirmForm.controls["lastName"].setValue(
            this.patient["lastName"]
          );
          this.confirmForm.controls["countrydialcode"].setValue(
            this.patient["patientPhoneCode"] === "+91" ? "+91" : "+1"
          );
          this.confirmForm.controls["mobile"].setValue(
            this.patient["patientPhone"]
          );
          this.confirmForm.controls["email"].setValue(
            this.patient["patientEmail"]
          );
          this.confirmForm.controls["gender"].setValue(this.patient["gender"]);
          this.changeMask("phonemask", this.patient["patientPhoneCode"]);
          this.confirmForm.controls["patientDob"].setValue(this.setDateToDatePicker1(this.patient["patientDob"]));
          if (this.patient["address"]) {
            this.confirmForm.controls["patientAddress1"].setValue(
              this.patient["address"]["addressLine1"]
            );
            this.confirmForm.controls["patientAddress2"].setValue(
              this.patient["address"]["addressLine2"]
            );

            this.confirmForm.controls["patientCity"].setValue(
              this.patient["address"]["cityName"]
            );
            this.confirmForm.controls["patientCountry"].setValue(
              this.patient["address"]["patientCountry"]
            );
            this.confirmForm.controls["patientZipCode"].setValue(
              this.patient["address"]["patientZipCode"]
            );
            if (this.patient["address"]["country"]) {
              this.confirmForm.controls["patientzipmask"].setValue(
                this.patient["address"]["country"]["id"] === 101
                  ? "000000"
                  : "00000"
              );
              this.getStateList(this.patient["address"]["country"]["id"]);
            }

            if (this.patient["address"]["state"]) {
              this.confirmForm.controls["patientState"].setValue(
                this.patient["address"]["state"]["id"]
              );
            }
          }
        } else {
          this.viewTestCenter();
        }
      } else {
        this.viewTestCenter();
      }
    }
  }

  getTasks() {
    return this.confirmForm.get("insuranceList")["controls"];
  }

  getStateList(countryid) {
    return this.patientFormService.getStateList(this, countryid);
  }

  changeCountry(countryid) {
    if (countryid && (countryid === 101 || countryid === "101")) {
      this.confirmForm.controls["patientzipmask"].setValue("000000");
    } else if (countryid && (countryid === 231 || countryid === "231")) {
      this.confirmForm.controls["patientzipmask"].setValue("00000");
    }
    this.confirmForm.controls["patientState"].setValue("");
    this.confirmForm.controls["patientZipCode"].setValue("");
    if (countryid) {
      this.getStateList(countryid);
    }
  }

  yesornochecked(type) {
    if (type === "no") {
      this.yesSelected = false;
      this.noSelected = true;

      this.answered = true;
    }
    if (type === "yes") {
      this.noSelected = false;
      this.yesSelected = true;
      this.answered = false;
    }
  }

  getcountry() {
    return this.patientFormService.getcountry(this);
  }

  getPhysicianList() {
    this.appservice.getSearchPhysician().subscribe((physicianlist: any) => {
      if (physicianlist.status.status === 200) {
        if (physicianlist.entity) {
          this.physicianList = physicianlist.entity;
          if (this.physicianList.length > 0) {
            this.physicianList.forEach((physician) => {
              physician.username =
                physician.firstName + " " + physician.lastName;
            });
          }
        }
      }
    });
  }

  onSelect(event: TypeaheadMatch): void {
    this.contryID = event.item.address.country.id;
    this.confirmForm.controls["countrydialcode"].setValue(
      event.item.address.country.countryDialCode
    );
    this.confirmForm.controls["physicianFirstName"].setValue(
      event.item.firstName
    );
    this.confirmForm.controls["physicianLastName"].setValue(
      event.item.lastName
    );
    this.confirmForm.controls["physicianMobile"].setValue(
      event.item.physicianPhone
    );
    this.confirmForm.controls["physicianMobileCode"].setValue(
      event.item.physicianPhoneCode
    );
    this.confirmForm.controls["physicianExtn"].setValue(
      event.item.physicianPhoneExtn
    );
    this.confirmForm.controls["physicianFax"].setValue(event.item.physicianFax);
    this.confirmForm.controls["faxCode"].setValue(event.item.physicianFaxCode);
    this.confirmForm.controls["faxExtn"].setValue(event.item.physicainFaxExtn);
    this.physicianId = event.item.id;
    this.confirmForm.controls["hmoFirstName"].setValue(
      event.item.assistantFirstName
    );
    this.confirmForm.controls["hmoLastName"].setValue(
      event.item.assistantLastName
    );
    this.confirmForm.controls["hmoMobile"].setValue(event.item.assistantPhone);
    this.confirmForm.controls["hmoMobileCode"].setValue(
      event.item.assistantPhoneCode
    );
    this.confirmForm.controls["hmoExtn"].setValue(
      event.item.assistantPhoneExtn
    );
    this.confirmForm.controls["doctorFirstName"].setValue(
      event.item.physicianContactFirstName
    );
    this.confirmForm.controls["doctorLastName"].setValue(
      event.item.physicianContactLastName
    );
    this.selectedName = event.item.firstName + " " + event.item.lastName;
  }

  changeMask(type, value) {
    if (type === "phonemask") {
      this.phonemask = this.appservice.checkDialCode(value);
      this.phonemask
        ? this.phonemask
        : this.testCountryCode === "US"
        ? "+1"
        : "+91";

        if(this.phonemask === '00000-00000') {
          this.confirmForm.controls["countrydialcode"].setValue("+91");
          this.confirmForm.controls["countrydialcode1"].setValue("+91");
        } else {
          this.confirmForm.controls["countrydialcode"].setValue("+1");
          this.confirmForm.controls["countrydialcode1"].setValue("+1");
        }
    } else if (type === "physicianmask") {
      this.physicianmask = this.appservice.checkDialCode(value);
      this.physicianmask
        ? this.physicianmask
        : this.testCountryCode === "US"
        ? "+1"
        : "+91";
    } else if (type === "alternativemask") {
      this.alternativemask = this.appservice.checkDialCode(value);
      this.alternativemask
        ? this.alternativemask
        : this.testCountryCode === "US"
        ? "+1"
        : "+91";
    } else if (type === "faxmask") {
      this.faxmask = this.appservice.checkDialCode(value);
      this.faxmask
        ? this.faxmask
        : this.testCountryCode === "US"
        ? "+1"
        : "+91";
    } else if (type === "hmomask") {
      this.hmomask = this.appservice.checkDialCode(value);
      this.hmomask
        ? this.hmomask
        : this.testCountryCode === "US"
        ? "+1"
        : "+91";
    }
  }

  maskChange(value, index) {
    if (value && (value === +91 || value === "+91")) {
      this.insuranceList[index].insuranceCustomerServiceMask =
        environment.indiaPhoneMask;
    } else if (value && (value === +1 || value === "+1")) {
      this.insuranceList[index].insuranceCustomerServiceMask =
        environment.usPhoneMask;
    }
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.confirmForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (!this.scheduleDetail.procedureInputs) {
      this.toastr.error("First Fill Schedule Appointment");
      this.router.navigate([
        `/${localStorage.getItem("testCode").toString()}/schedule-appointment`,
      ]);
    }

    if (this.confirmForm.controls.preReminder.invalid) {
      this.scrollTop("remainderdiv");
      return;
    }

    if (this.confirmForm.controls.moreDetails.invalid) {
      this.scrollTop("answerdiv");
      return;
    }

    if (this.confirmForm.invalid) {
      return;
    }

    for (let index = 0; index < this.insuranceList.length; index++) {
      if (this.insuranceList[index].insuranceCustomerService) {
        if (this.insuranceList[index].insuranceCustomerService.length < 10) {
          return;
        }
      }
    }

    if (this.scheduleDetail.procedureInputs) {
      this.isSubmit = true;
      this.addPatientDetail();
    } else {
      this.toastr.error("First Fill Schedule Appointment");
      this.router.navigate([
        `/${localStorage.getItem("testCode").toString()}/schedule-appointment`,
      ]);
    }
  }

  scrollTop(value) {
    return this.patientFormService.scrollTop(this, value);
  }

  addorupdatemedicalquestion(scheduleappointmentid) {
    this.appservice.getmedicalqns(scheduleappointmentid).subscribe((res) => {
      if (res && res["entity"]) {
        this.medicalQuestionBySchedId = res["entity"];
        for (
          let index = 0;
          index < this.medicalQuestionBySchedId.length;
          index++
        ) {
          for (let i = 0; i < this.medicalqnsList.length; i++) {
            if (
              this.medicalQuestionBySchedId[index].tcProcedureView &&
              this.medicalQuestionBySchedId[index].tcProcedureView["cptCode"] &&
              this.medicalQuestionBySchedId[index].tcProcedureView[
                "cptCode"
              ] === this.medicalqnsList[i].tcProcedureView["cptCode"]
            ) {
              this.medicalqnsList[
                i
              ].tcProcedureView = this.medicalQuestionBySchedId[
                index
              ].tcProcedureView;
              break;
            }
          }

          if (index + 1 === this.medicalQuestionBySchedId.length) {
            const data = {
              scheduleAppointmentId: scheduleappointmentid,
              tcProMedQuesOut: this.medicalqnsList,
            };
            this.appservice
              .addorupdateschedmedicalquestions(data)
              .subscribe((res) => ({}));
          }
        }
      }
    });
  }

  addPatientDetail() {
    const params: any = {};
    params.patientFirstName = this.confirmForm.controls["firstName"].value;
    params.patientLastName = this.confirmForm.controls["lastName"].value;
    params.patientEmail = this.confirmForm.controls["email"].value;
    params.patientPhoneCode = this.confirmForm.controls[
      "countrydialcode"
    ].value;
    params.patientPhone = this.confirmForm.controls["mobile"].value;
    params.altPatientPhoneCode = this.confirmForm.controls[
      "alternativeCode"
    ].value;
    params.altPatientPhone = this.confirmForm.controls[
      "alternativeMobile"
    ].value;
    params.altPatientPhoneExtn = this.confirmForm.controls[
      "alternativeExtn"
    ].value;
    params.patientId =
      this.scheduleDetail.patientDetail &&
      this.scheduleDetail.patientDetail.patientId
        ? this.scheduleDetail.patientDetail.patientId
        : "";
    params.gender = this.confirmForm.controls["gender"].value;

    this.appservice.addorupdatepatient(params).subscribe(
      (patientDetail: any) => {
        if (patientDetail.status.status === 200) {
          if (
            this.scheduleDetail.payMode === "insurance" &&
            this.insuranceList &&
            this.insuranceList.length > 0
          ) {
            var schedInsuranceInput = [];
            for (let index = 0; index < this.insuranceList.length; index++) {
              schedInsuranceInput.push({
                insuranceGroupNumber: this.insuranceList[index]
                  .insuranceGroupNumber,
                insuranceIdNumber: this.insuranceList[index].insuranceIdNumber,
                insuranceCustomerCode: this.insuranceList[index]
                  .insuranceCustomerCode,
                insuranceCustomerService: this.insuranceList[index]
                  .insuranceCustomerService,
                insurance: { id: this.insuranceList[index].insuranceId },
                insuranceType: { id: this.insuranceList[index].insuranceType },
              });
            }
          }
          delete params.patientId;
          params.id = patientDetail.entity.id;
          const params1: any = {
            userId: sessionStorage.getItem("userid"),
            scheduleId:
              this.scheduleDetail.patientDetail &&
              this.scheduleDetail.patientDetail.id
                ? this.scheduleDetail.patientDetail.id
                : "",
            scheduledOn: this.scheduleDetail.scheduleOn,
            scheduledOnStr: this.scheduleDetail.scheduleOn,
            choosenLocation: this.scheduleDetail.location,
            latitude: this.scheduleDetail.latitude,
            longitude: this.scheduleDetail.longitude,
            payMode: this.scheduleDetail.payMode,
            schedInsuranceInput:
              schedInsuranceInput && schedInsuranceInput.length > 0
                ? schedInsuranceInput
                : null,
            procedureInputs: this.scheduleDetail.procedureInputs,
            preAuthorized: this.confirmForm.controls["preAutherize"].value,
            scheduleFromTime: this.scheduleDetail.procedureInputs[0].startTime,
            scheduleToTime: this.scheduleDetail.procedureInputs[0].endTime,
            timeZone: this.scheduleDetail.timeZone,
            schedMed: true,
            schedStatusId: 1,
            testCenterId: localStorage.getItem("testCenterId").toString(),
            patientType: "IC",
          };
          params1.patient = params;
          params1.patient.firstName = this.confirmForm.controls[
            "firstName"
          ].value;
          params1.patient.lastName = this.confirmForm.controls[
            "lastName"
          ].value;
          this.appservice.scheduleappointment(params1).subscribe(
            (schedule: any) => {
              if (schedule.status.status === 200) {
                if (schedule.entity) {
                  setTimeout(() => {
                    this.updateScheduleDetail(schedule);
                  }, 200);
                  this.addorupdatemedicalquestion(schedule["entity"]["id"]);
                }

                this.support.sidemenuname.next(
                  `/${localStorage
                    .getItem("testCode")
                    .toString()}/home-calendar`
                );
                this.router.navigate([
                  `/${localStorage
                    .getItem("testCode")
                    .toString()}/home-calendar`,
                ]);
              } else if (schedule.status.status === 230) {
                this.toastr.error(schedule.status.msg);
                this.isSubmit = false;
              } else if (schedule.status.status === 302) {
                this.toastr.error(schedule.status.msg);
                this.isSubmit = false;
              }
            },
            (err) => {
              this.isSubmit = false;
              this.toastr.error(err.error.status.msg);
            }
          );
        }
      },
      (err) => {
        this.isSubmit = false;
      }
    );
  }

  chkLength(data) {
    return chkLengthUtil(data);
  }

  updateScheduleDetail(schedule?: any) {
    let patientdob = null;

    if (
      this.confirmForm.controls["patientDob"].value !== null &&
      this.showMoreDetails === true
    ) {
      patientdob = this.datePipe.transform(this.confirmForm.controls["patientDob"].value, 'yyyy-MM-dd');
    }
    const updateSchedule: any = {};
    updateSchedule.active = this.scheduleDetail.patientDetail
      ? this.patientDetail.active
      : schedule.entity.active;
    updateSchedule.choosenLocation = this.scheduleDetail.patientDetail
      ? this.patientDetail.choosenLocation
      : schedule.entity.choosenLocation;
    updateSchedule.createdOn = this.scheduleDetail.patientDetail
      ? this.patientDetail.createdOn
      : schedule.entity.createdOn;
    updateSchedule.deleted = this.scheduleDetail.patientDetail
      ? this.patientDetail.deleted
      : schedule.entity.deleted;
    updateSchedule.id = this.scheduleDetail.patientDetail
      ? this.patientDetail.id
      : schedule.entity.id;

    if (this.scheduleDetail.patientDetail) {
      if (
        this.scheduleDetail.payMode === "insurance" &&
        this.scheduleDetail.patientDetail &&
        this.scheduleDetail.patientDetail["schedInsuranceId"]
      ) {
        updateSchedule.schedInsuranceId = this.scheduleDetail.patientDetail[
          "schedInsuranceId"
        ];
      }
    } else {
      if (
        this.scheduleDetail.payMode === "insurance" &&
        schedule["entity"] &&
        schedule["entity"]["schedInsurance"]
      ) {
        updateSchedule.schedInsuranceId =
          schedule["entity"]["schedInsurance"]["id"];
      }
    }

    if (
      this.insuranceList.length > 0 &&
      this.scheduleDetail.payMode === "insurance"
    ) {
      updateSchedule.insuranceCustomerCode = this.insuranceList[0].insuranceCustomerCode;
      updateSchedule.insuranceCustomerService = this.insuranceList[0].insuranceCustomerService;
      updateSchedule.insuranceGroupNumber = this.insuranceList[0].insuranceGroupNumber;
      updateSchedule.insuranceIdNumber = this.insuranceList[0].insuranceIdNumber;
      updateSchedule.insuranceType = this.insuranceList[0].insuranceType;
      updateSchedule.insurance = this.insuranceList[0].insuranceId;
    }

    updateSchedule.latitude = this.scheduleDetail.patientDetail
      ? this.patientDetail.latitude
      : schedule.entity.latitude;
    updateSchedule.longitude = this.scheduleDetail.patientDetail
      ? this.patientDetail.longitude
      : schedule.entity.longitude;
    updateSchedule.patientAddressId = "";
    updateSchedule.patientAddressLine1 = this.confirmForm.controls[
      "patientAddress1"
    ].value;
    updateSchedule.patientAddressLine2 = this.confirmForm.controls[
      "patientAddress2"
    ].value;
    updateSchedule.patientAreaName = "";
    updateSchedule.patientCityName = this.confirmForm.controls[
      "patientCity"
    ].value;
    updateSchedule.patientCountry = this.confirmForm.controls[
      "patientCountry"
    ].value;
    updateSchedule.patientDob = patientdob;
    updateSchedule.patientEmail = this.scheduleDetail.patientDetail
      ? this.confirmForm.controls["email"].value
      : schedule.entity.patient.patientEmail;
    updateSchedule.patientFirstName = this.confirmForm.controls[
      "firstName"
    ].value;
    updateSchedule.patientGender = this.confirmForm.controls["gender"].value;
    updateSchedule.patientId = this.scheduleDetail.patientDetail
      ? this.patientDetail.patientId
      : schedule.entity.patient.id;
    updateSchedule.patientLastName = this.confirmForm.controls[
      "lastName"
    ].value;
    updateSchedule.patientPhone = this.scheduleDetail.patientDetail
      ? this.confirmForm.controls["mobile"].value
      : schedule.entity.patient.patientPhone;
    updateSchedule.patientPhoneCode = this.scheduleDetail.patientDetail
      ? this.confirmForm.controls["countrydialcode"].value
      : schedule.entity.patient.patientPhoneCode;
    updateSchedule.patientPhoneExtn = this.confirmForm.controls[
      "mobileExtn"
    ].value;
    updateSchedule.altPatientPhoneExtn = this.confirmForm.controls[
      "alternativeExtn"
    ].value;
    updateSchedule.altPatientPhone = this.confirmForm.controls[
      "alternativeMobile"
    ].value;
    updateSchedule.altPatientPhoneCode = this.confirmForm.controls[
      "alternativeCode"
    ].value;
    updateSchedule.patientState = this.confirmForm.controls[
      "patientState"
    ].value;
    updateSchedule.patientZipCode = this.confirmForm.controls[
      "patientZipCode"
    ].value;
    updateSchedule.payMode = this.scheduleDetail.patientDetail
      ? this.patientDetail.payMode
      : schedule.entity.payMode;
    updateSchedule.physicianAddressId = "";
    updateSchedule.physicianAddressLine1 = "";
    updateSchedule.physicianAddressLine2 = "";
    updateSchedule.physicianAreaName = "";
    updateSchedule.physicianCityName = "";
    updateSchedule.physicianCountry = this.contryID;
    updateSchedule.physicianDob = "";
    updateSchedule.physicianEmail = "";
    updateSchedule.physicianFax = this.confirmForm.controls[
      "physicianFax"
    ].value;
    updateSchedule.physicianFaxCode = this.confirmForm.controls[
      "faxCode"
    ].value;
    updateSchedule.physicianExtn = this.confirmForm.controls[
      "physicianExtn"
    ].value;
    updateSchedule.physicianFirstName = this.confirmForm.controls[
      "physicianFirstName"
    ].value;
    updateSchedule.physicianGender = "";
    updateSchedule.physicianId = this.physicianId ? this.physicianId : "";
    updateSchedule.physicianLastName = this.confirmForm.controls[
      "physicianLastName"
    ].value;
    updateSchedule.physicianPhone = this.confirmForm.controls[
      "physicianMobile"
    ].value;
    updateSchedule.physicianPhoneCode = this.confirmForm.controls[
      "physicianMobileCode"
    ].value;
    updateSchedule.physicianFaxExtn = this.confirmForm.controls[
      "faxExtn"
    ].value;
    updateSchedule.physicianContactFirstName = this.confirmForm.controls[
      "doctorFirstName"
    ].value;
    updateSchedule.physicianContactLastName = this.confirmForm.controls[
      "doctorLastName"
    ].value;
    updateSchedule.assistantFirstName = this.confirmForm.controls[
      "hmoFirstName"
    ].value;
    updateSchedule.assistantLastName = this.confirmForm.controls[
      "hmoLastName"
    ].value;
    updateSchedule.assistantPhone = this.confirmForm.controls[
      "hmoMobile"
    ].value;
    updateSchedule.assistantPhoneCode = this.confirmForm.controls[
      "hmoMobileCode"
    ].value;
    updateSchedule.assistantPhoneExtn = this.confirmForm.controls[
      "hmoExtn"
    ].value;

    updateSchedule.physicianState = "";
    updateSchedule.physicianZipCode = "";
    updateSchedule.preAuthorized = false;
    updateSchedule.reSchedule = this.scheduleDetail.patientDetail
      ? "true"
      : "false";
    updateSchedule.schedMed = true;
    updateSchedule.scheduleFromTime = this.scheduleDetail.patientDetail
      ? this.scheduleDetail.scheduleFromTime
      : schedule.entity.scheduleFromTime;
    updateSchedule.scheduleToTime = this.scheduleDetail.patientDetail
      ? this.scheduleDetail.scheduleToTime
      : schedule.entity.scheduleToTime;
    updateSchedule.scheduledOn = this.scheduleDetail.patientDetail
      ? this.scheduleDetail.scheduleOn
      : schedule.entity.scheduledOn;
    updateSchedule.scheduledOnStr = updateSchedule.scheduledOn;
    updateSchedule.testCenterId = localStorage
      .getItem("testCenterId")
      .toString();
    updateSchedule.timezone = this.scheduleDetail.patientDetail
      ? this.patientDetail.timezone
      : schedule.entity.timezone;
    updateSchedule.totalAmount = this.scheduleDetail.patientDetail
      ? this.patientDetail.totalAmount
      : schedule.entity.totalAmount;
    updateSchedule.hearedAboutUs = this.confirmForm.controls["hearAbout"].value;
    updateSchedule.others = this.confirmForm.controls["hearOthers"].value;
    updateSchedule.answered = this.confirmForm.controls["preNeed"].value;
    updateSchedule.notification = this.confirmForm.controls[
      "preReminder"
    ].value;
    this.appservice.updatescheduleappointment(updateSchedule).subscribe(
      (data: any) => {
        this.isSubmit = false;
        if (data.status.status === 200) {
          sessionStorage.removeItem("scheduleData");
          if (this.scheduleDetail.patientDetail) {
            this.toastr.success("Appointments Rescheduled Successfully");
          } else {
            this.toastr.success("Appointments Scheduled Successfully");
          }
          if (sessionStorage.getItem("waitingid")) {
            this.appservice
              .updateWaitingList(sessionStorage.getItem("waitingid"))
              .subscribe((res) => ({}));
          }

          sessionStorage.removeItem("waitingid");
          sessionStorage.removeItem("waitinglistpatient");
        }
      },
      (err) => {
        this.isSubmit = false;
      }
    );
  }
}
